<!-- 
Contents of the LEVY CALCULATION tab of the levy collection provider page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      :title="title" 
      :subtitle="subtitle" 
      user-guide-topic="levy-collection-providers"
      user-guide-section="levy-calculation"
    >
      <template v-slot:additional-nav>
        <div class="hidden-md-and-down" style="position:relative;top:-4px;">
          <v-btn 
            :to="`/providers/${providerId}`" flat small color="primary" 
            class="mt-0 mb-0 mr-0"
          >
            <v-icon class="mr-2">school</v-icon>
            Go to provider
          </v-btn>
          <our-next-previous-navigator
            :nav-url="`/levy-collections/${levyCollectionId}/providers/:id/calculation`"
            :next-page-action="nextPageAction"
            :previous-page-action="previousPageAction"
            id-field="providerId"
            module="levyCollectionProviders"
            class="mb-0"
          />
        </div>
      </template>
      <template v-slot:prefix>
        <favourite-indicator :provider="provider" />
      </template>
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" :sandbox="isSandbox" />
      </template>
    </our-heading>
    <tabs ref="tabs" :levy-collection-id="levyCollectionId" :provider-id="providerId">
      <incomplete-levy-parameters-warning-panel :levy-collection-provider="provider" />
      <our-loading-indicator v-if="state.loading" />
      <levy-calculation-panel
        v-else
        :levy-collection="levyCollection"
        :levy-collection-provider="provider"
        mode="internal"
      />
    </tabs>
  </div>
</template>

<script>
import FavouriteIndicator from "@/components/levy-collection-providers/FavouriteIndicator.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import IncompleteLevyParametersWarningPanel from "@/components/levy-collection-providers/IncompleteLevyParametersWarningPanel.vue";
import LevyCalculationPanel from "@/components/levy-collection-providers/calculation/LevyCalculationPanel.vue";
import levyCollectionProviderMixins from "./mixins";

export default {
  name: "LevyCollectionProviderCalculation",
  components: {
    FavouriteIndicator,
    Tabs,
    LevyCalculationPanel,
    LevyCollectionNavigator,
    IncompleteLevyParametersWarningPanel
  },
  mixins: [levyCollectionProviderMixins]
};
</script>
